import React from "react";
import { Modal, Button } from "react-bootstrap";

//STYLES
import * as ViewerStyles from "../styles/videoViewer";

import "../styles/viewer.css";

function VideoViewer(props) {
    function getVideoId(url) {
        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        const match = url.match(regExp);

        return match && match[2].length === 11 ? match[2] : null;
    }

    return (
        <div>
            <Modal dialogClassName="modal-width" show={props.open} onHide={props.handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Video</Modal.Title>
                </Modal.Header>
                <Modal.Body className="modal-height">
                    <iframe
                        width="560"
                        height="315"
                        src={`//www.youtube.com/embed/${getVideoId(props.videoURL)}`}
                        title="YouTube video player"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                    ></iframe>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={props.handleClose}>Close</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default VideoViewer;
